// transaction/enums.ts
var TransactionStatus = /* @__PURE__ */ ((TransactionStatus2) => {
  TransactionStatus2["DRAFT"] = "draft";
  TransactionStatus2["PENDING"] = "pending";
  TransactionStatus2["AUTHORIZED"] = "authorized";
  TransactionStatus2["PROCESSING"] = "processing";
  TransactionStatus2["VERIFYING"] = "verifying";
  TransactionStatus2["COMPLETED"] = "completed";
  TransactionStatus2["SETTLED"] = "settled";
  TransactionStatus2["DECLINED"] = "declined";
  TransactionStatus2["FAILED"] = "failed";
  TransactionStatus2["CANCELLED"] = "cancelled";
  TransactionStatus2["REFUNDED"] = "refunded";
  TransactionStatus2["VOIDED"] = "voided";
  return TransactionStatus2;
})(TransactionStatus || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["ACH"] = "ach";
  PaymentMethod2["CASH"] = "cash";
  return PaymentMethod2;
})(PaymentMethod || {});
var AchProcessingSpeed = /* @__PURE__ */ ((AchProcessingSpeed2) => {
  AchProcessingSpeed2["STANDARD"] = "standard";
  AchProcessingSpeed2["SAME_DAY"] = "same-day";
  return AchProcessingSpeed2;
})(AchProcessingSpeed || {});
var BankAccountType = /* @__PURE__ */ ((BankAccountType2) => {
  BankAccountType2["CHECKING"] = "checking";
  BankAccountType2["SAVINGS"] = "savings";
  return BankAccountType2;
})(BankAccountType || {});
var PaymentProvider = /* @__PURE__ */ ((PaymentProvider2) => {
  PaymentProvider2["ACHPC"] = "achpc";
  PaymentProvider2["AEROPAY"] = "aeropay";
  PaymentProvider2["MANUAL"] = "manual";
  return PaymentProvider2;
})(PaymentProvider || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["USD"] = "USD";
  return Currency2;
})(Currency || {});

export {
  TransactionStatus,
  PaymentMethod,
  AchProcessingSpeed,
  BankAccountType,
  PaymentProvider,
  Currency
};
